<ol *ngIf="isOrderedList" [ngStyle]="listStyle">
  <li *ngFor="let item of items" [ngStyle]="itemStyle">
    {{ item }}
  </li>
</ol>

<ul *ngIf="!isOrderedList" [ngStyle]="listStyle">
  <li *ngFor="let item of items" [ngStyle]="itemStyle">
    {{ item }}
  </li>
</ul>
